var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5521 14.5499C26.8253 14.267 26.9765 13.8881 26.9731 13.4948C26.9697 13.1015 26.8119 12.7253 26.5338 12.4472C26.2557 12.169 25.8795 12.0113 25.4862 12.0079C25.0929 12.0045 24.714 12.1556 24.4311 12.4289L16.4811 20.3789L11.5311 15.4289C11.2482 15.1556 10.8693 15.0045 10.476 15.0079C10.0827 15.0113 9.70647 15.169 9.42835 15.4472C9.15024 15.7253 8.99249 16.1015 8.98907 16.4948C8.98565 16.8881 9.13684 17.267 9.41008 17.5499L15.4101 23.5499C15.6914 23.8311 16.0728 23.9891 16.4706 23.9891C16.8683 23.9891 17.2498 23.8311 17.5311 23.5499L26.5311 14.5499H26.5521Z",
    fill: "#68C230",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 18C36 27.93 27.93 36 18 36C8.07 36 0 27.93 0 18C0 8.07 8.07 0 18 0C27.93 0 36 8.07 36 18ZM33 18C33 26.28 26.28 33 18 33C9.72 33 3 26.28 3 18C3 9.72 9.72 3 18 3C26.28 3 33 9.72 33 18Z",
    fill: "#68C230",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.5a92ad736fc02c65fa670266fce2b2e7.svg";
export { ForwardRef as ReactComponent };